import {getCookie} from '../../utils/cookies'
import {lastAppLockedAnchorDealImpressionsTimestampConfig} from './cookieConfig'

/**
 * Gets the last app locked anchor deal impressions timestamp from cookies.
 * @returns The last impressions timestamp string or undefined
 */
export const getLastAppLockedAnchorDealImpressionsTimestamp = () =>
  getCookie(lastAppLockedAnchorDealImpressionsTimestampConfig.name)
